import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props, u ) => {

	return {
		container: {
			flex   : "1",
			height : "100vh"
		},
		playerContainer: {
			height         : "100%",
			display        : "flex",
			flexDirection  : "column",
			justifyContent : "center",
			background     : "black"
		},
		cardsContainer: {
			padding: "0"
		},
		videosPageContainer: {
			minHeight : "calc(100vh - 70px)",
			display   : "flex"
		},
		playerBodyContainer: {
			padding : "2rem",
			width   : "100%",

			[rooterMediaQuery.mobile]: {
				padding: "unset"

			}
		},
		rightSideBarContainer: {
			display         : "flex",
			flexDirection   : "column",
			alignItems      : "flex-start",
			position        : "sticky",
			height          : "90vh",
			width           : "100%",
			top             : "70px",
			maxWidth        : "25vw",
			backgroundColor : "inherit",
			overflow        : "auto"
		},
		inputComment: {
			width                   : "100%",
			backgroundColor         : theme.other.darkMode ? theme.other.colors.dialog.primary : theme.other.paletteNew.secondaryLightGrey,
			borderBottomLeftRadius  : "1rem",
			borderBottomRightRadius : "1rem",
			border                  : theme.other.darkMode ? "unset" : `1px solid ${ theme.other.paletteNew.secondaryLightGrey }`
		},
		videoChatContainer: {
			padding : "2rem 1rem 2rem 1rem",
			width   : "100%",

			[rooterMediaQuery.mobile]: {
				height     : "68vh",
				background : theme.other.colors.background.secondary
			}
		},
		videosChatHeader: {
			width           : "100%",
			padding         : "1rem 1.5rem",
			backgroundColor : theme.other.colors.dialog.primary,
			borderRadius    : props?.collapse ? "1rem 1rem 0 0" : "1rem",
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "space-between",
			border          : theme.other.darkMode ? "unset" : `1px solid ${ theme.other.paletteNew.secondaryLightGrey }`,
			cursor          : "pointer",

			"&:hover": {
				background: theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.secondaryLightGrey
			}
		},
		appBar: {
			// backgroundColor : theme.other.colors.dialog.primary,
			color: theme.other.colors.text.primary

		},
		dialogRoot: {
			[u.smallerThan ( "lg" )]: {
				width  : "600px",
				height : "400px"
			},
			[u.largerThan ( "md" )]: {
				width  : "800px",
				height : "600px"
			},
			[u.largerThan ( "lg" )]: {
				width  : "1200px",
				height : "800px"
			},
			borderRadius    : "15px",
			backgroundColor : theme.other.colors.dialog.secondary
		},
		itemList: {
			height      : props?.displayEmoji ? "calc(55vh - 210px)" : "55vh",
			borderLeft  : theme.other.darkMode ? "unset" : `1px solid ${ theme.other.paletteNew.secondaryLightGrey }`,
			borderRight : theme.other.darkMode ? "unset" : `1px solid ${ theme.other.paletteNew.secondaryLightGrey }`
		},
		arrowIcon: {
			height : "2rem",
			width  : "2rem",
			cursor : "pointer"
		},
		commentCount: {
			fontSize   : "1.7rem",
			fontWeight : "500"
		},
		emojiModalParent: {
			position : "relative",
			height   : props?.displayEmoji ? "210px" : 0,
			// transition : "height 1s ease-in-out",

			"& .EmojiPickerReact li.epr-emoji-category>.epr-emoji-category-label": {
				color: `${ theme.other.colors.text.primary } !important`
			}
		},
		emojiModalWrapper: {
			width       : "100%",
			position    : "absolute",
			borderLeft  : theme.other.darkMode ? "unset" : `1px solid ${ theme.other.paletteNew.secondaryLightGrey }`,
			borderRight : theme.other.darkMode ? "unset" : `1px solid ${ theme.other.paletteNew.secondaryLightGrey }`
		},

		// mobile css
		mobileCommentsContainer: {
			height   : "65.5vh",
			overflow : "hidden"
		},

		headerTitle: {
			fontWeight: "500"
		},

		mobileHeader: {
			padding        : "1rem",
			background     : theme.other.colors.dialog.primary,
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			borderBottom   : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`
		},

		closeIcon: {
			height : "3rem",
			width  : "3rem"
		},

		mobileCommentsList: {
			backgroundColor : theme.other.colors.background.secondary,
			height          : "100%"
		},
		mobileInputContainet: {
			position : "absolute",
			bottom   : "0",
			width    : "100%"
		},
		adContainer: {
			width          : "100%",
			display        : "flex",
			justifyContent : "center"
		}
	};
} );
